export const DATA_PROVIDER_NAME = 'pianocontireport/contoeconomico'